module.exports = __webpack_public_path__ + "static/img/MOUSE.6b12d25e.png";